export const GoogleAnalyticsGlobalIndex = '__gaJavelin';

export class GoogleAnalytics {
  scriptSyncId = 'gaScriptSync';
  scriptAsyncId = 'gaScriptAsync';
  nonceAsync = '';
  nonceSync = '';

  constructor(gaCode, gaConfig, additionalGaCode, timeout, options) {
    this.gaConfig = gaConfig ? gaConfig : {};
    this.gaCode = gaCode;
    this.timeout = timeout || 5000;
    this.additionalGaCode = additionalGaCode;
    this.options = options;

    if (this.options) {
      const { nonce } = this.options;
      this.nonceAsync = nonce && nonce[0] ? nonce[0] : '';
      this.nonceSync = nonce && nonce[1] ? nonce[1] : '';
    }
  }

  outputOnResolve() {
    return {
      pageview: this.pageview,
      event: this.event,
      gtag: this.gtag,
    };
  }

  initialize() {
    return new Promise((resolve, reject) => {
      if (GoogleAnalytics.isInitialized()) {
        reject(new Error('GoogleAnalytics is being initialized'));
      }

      // in case of retry logics, remove previous scripts
      const previousScriptAsync = document.getElementById(this.scriptAsyncId);
      if (previousScriptAsync) {
        previousScriptAsync.remove();
      }

      const head = document.getElementsByTagName('head')[0];
      const scriptAsync = document.createElement('script');
      scriptAsync.setAttribute('id', this.scriptAsyncId);
      scriptAsync.setAttribute('async', '');

      if (
        this.nonceAsync &&
        typeof this.nonceAsync === 'string' &&
        this.nonceAsync.length > 0
      ) {
        scriptAsync.setAttribute('nonce', this.nonceAsync);
      }

      scriptAsync.setAttribute(
        'src',
        `https://www.googletagmanager.com/gtag/js?id=${this.gaCode}`
      );
      scriptAsync.onload = () => {
        const target = document.getElementById(this.scriptSyncId);
        if (target) {
          target.remove();
        }

        // in case of retry logics, remove previous script sync
        const previousScriptSync = document.getElementById(this.scriptSyncId);
        if (previousScriptSync) {
          previousScriptSync.remove();
        }

        const scriptSync = document.createElement('script');

        scriptSync.setAttribute('id', this.scriptSyncId);

        if (
          this.nonceSync &&
          typeof this.nonceSync === 'string' &&
          this.nonceSync.length > 0
        ) {
          scriptSync.setAttribute('nonce', this.nonceSync);
        }

        let scriptHTML = `window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);};
        gtag('js', new Date());
        gtag('config', '${this.gaCode}', ${JSON.stringify(this.gaConfig)});`;

        if (this.additionalGaCode) {
          this.additionalGaCode.forEach((code) => {
            scriptHTML += `\ngtag('config', '${code}', ${JSON.stringify(
              this.gaConfig
            )});`;
          });
        }

        scriptSync.innerHTML = scriptHTML;

        head.appendChild(scriptSync);

        const resolved = this.outputOnResolve();

        Object.assign(window, { [GoogleAnalyticsGlobalIndex]: resolved });

        resolve(resolved);
      };

      scriptAsync.onerror = (event) => {
        if (typeof event === 'string') {
          console.error(`GoogleAnalytics intialization failed ${event}`);
        } else {
          const error = new Error();
          error.name = 'GoogleAnalytics intialization failed';
          error.message = JSON.stringify(event, [
            'message',
            'arguments',
            'type',
            'name',
          ]);
          console.error(error);
        }
      };

      const onChangeReadyState = () => {
        switch (document.readyState) {
          case 'interactive':
          case 'complete':
            if (!GoogleAnalytics.isInitialized()) {
              head.appendChild(scriptAsync);
              document.removeEventListener(
                'readystatechange',
                onChangeReadyState
              );
            }
            break;
          default:
            break;
        }
      };

      if (document.readyState !== 'complete') {
        document.addEventListener('readystatechange', onChangeReadyState);
      } else {
        onChangeReadyState();
      }
    });
  }

  pageview(path, location, title) {
    return this.gtag('event', 'page_view', {
      page_path: path,
      page_location: location || window.location,
      page_title: title || document.title,
    });
  }

  event(action, { label, category, non_interaction, ...params }) {
    let options = params || {};
    if (label) options.event_label = label;
    if (category) options.event_category = category;
    if (non_interaction) options.non_interaction = non_interaction;

    return this.gtag('event', action, options);
  }

  gtag(...args) {
    if (typeof window.gtag === 'undefined') {
      return;
    }
    return window.gtag(...args);
  }

  static isInitialized() {
    switch (typeof window[GoogleAnalyticsGlobalIndex] !== 'undefined') {
      case true:
        return true;
      default:
        return false;
    }
  }

  static getGoogleAnalytics() {
    if (GoogleAnalytics.isInitialized()) {
      return window[GoogleAnalyticsGlobalIndex];
    } else {
      console.error(new Error('GoogleAnalytics is not initialized'));
    }
  }
}

export default GoogleAnalytics;
